import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { UPDATE_PERMITTED_MODULE_LIST } from "app/redux/constant/ActionType";
import { TIMEZONE_STR } from "app/shared/utility/helperStrings";
import { setupAutoLogout } from "app/views/Auth/Login/sessionManager";
import FetchWorkingDays from "app/views/Admin/WorkingDay/Services/fetchCompanyProfile";
import Url from "app/shared/constants/Url";
import Preloader from "app/shared/components/Preloader";
import SsoError from "./SsoError";
import moment from "moment";

const qs = require("qs");

const mapDispatchToProps = (dispatch) => ({
  updateModuleList: (payload) =>
    dispatch({ type: UPDATE_PERMITTED_MODULE_LIST, payload }),
});

class SsoCallback extends Component {
  state = {
    errorMsg: null,
  };

  componentDidMount() {
    this._exchangeToken();
  }

  _goToLogin = () => {
    window.location.href = "/auth/login";
  };

  _exchangeToken = async () => {
    const params    = new URLSearchParams(window.location.search);
    const ssoToken  = params.get("sso_token");
    const ssoError  = params.get("sso_error");

    // ── Handle backend-reported SSO errors → show the error screen ────────
    if (ssoError) {
      this.setState({ errorMsg: decodeURIComponent(ssoError) });
      return;
    }

    if (!ssoToken) {
      this.setState({
        errorMsg: "SSO session token missing. Please try logging in again.",
      });
      return;
    }

    try {
      // ── POST /sso/exchange — one-time token → full user data ───────────
      const response = await axios.post(
        Url.ssoExchange,
        qs.stringify({ sso_token: ssoToken }),
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      );

      if (response.data.status !== 200) {
        // Backend returned an error (expired token, invalid token, etc.)
        this.setState({
          errorMsg: response.data.msg || "SSO login failed. Please try again.",
        });
        return;
      }

      const data = response.data.data;

      // ── Build permitted module list — identical to LoginForm ──────────
      const { kpi_flag, overview_flag } = data;
      let tempList = [...(data.module || [])];

      if (kpi_flag)      tempList.push({ module_name: "kpi",      status: kpi_flag });
      if (overview_flag) tempList.push({ module_name: "overview", status: overview_flag });

      this.props.updateModuleList(tempList.filter((item) => item.status));

      // ── Resolve timezone — identical to LoginForm ─────────────────────
      const userTZ =
        data.time_zone ||
        data.user_time_zone ||
        Intl.DateTimeFormat().resolvedOptions().timeZone;

      // ── Persist session — identical keys/values to LoginForm ──────────
      localStorage.setItem("login_type",  String(data.login_type ?? "sso"));
      localStorage.setItem("userData",    JSON.stringify(data));
      localStorage.setItem("userId",      data.user_id);
      localStorage.setItem("token",       data.auth_key);
      localStorage.setItem("springToken", data.auth_key);
      localStorage.setItem(TIMEZONE_STR,  userTZ);
      moment.tz.setDefault(userTZ);

      // ── Fetch working-day calendar (needs token + userId in localStorage)
      try {
        const wdData = await FetchWorkingDays();
        if (wdData) {
          localStorage.setItem("workingDays", JSON.stringify(wdData?.data));
        }
      } catch (_err) {
        // Non-fatal — app works without working-days data
        console.warn("[SsoCallback] Could not fetch working days:", _err?.message);
      }

      setupAutoLogout();

      // ── Email-link course start: check sessionStorage first ───────────────
      // EmailCourseStart.js stores the destination here before triggering SSO.
      // sessionStorage survives same-tab redirects, so it's available here.
      const postSsoRedirect = sessionStorage.getItem("post_sso_redirect");
      if (postSsoRedirect) {
        sessionStorage.removeItem("post_sso_redirect");
        window.location.href = postSsoRedirect;
        return;
      }

      const subDomain = data.sub_domain?.trim().toLowerCase() || "hselms";

      if (subDomain === "hselms") {
        window.location.href = `https://${subDomain}.clideanalyser.in/elearning/12/dashboard`;
        return;
      }

      if (subDomain === "nscindia") {
        window.location.href = `https://${subDomain}.clideanalyser.in/survey`;
        return;
      }

      window.location.href = "/";

    } catch (err) {
      console.error("[SsoCallback] Token exchange failed:", err?.message);
      this.setState({ errorMsg: "SSO login error. Please try again." });
    }
  };

  render() {
    const { errorMsg } = this.state;

    // Any SSO failure → proper full-screen error page
    if (errorMsg) {
      return <SsoError message={errorMsg} onBackToLogin={this._goToLogin} />;
    }

    // Show the app's existing loading spinner while the exchange is in flight
    return <Preloader />;
  }
}

export default connect(null, mapDispatchToProps)(SsoCallback);
